import { AxiosInstance, isAxiosError } from "axios";
import { Favorito } from "./favorito";

export class FavoritoRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async listar(): Promise<Favorito[]> {
        try {
            let { data } = await this.api.get<Favorito[]>(`favoritos`)
            return data
        } catch (err) {
            if (isAxiosError(err)) {
                throw new Error(err.response?.data?.error || "Não foi possível listar os favoritos")
            }
            if (err instanceof Error) {
                throw err
            }
            throw new Error("Não foi possível listar os favoritos")
        }
    }
    async save(record: Favorito): Promise<Favorito> {
        try {
            let { data } = await this.api.post<Favorito>(`favoritos`, record)
            return data
        } catch (err) {
            if (isAxiosError(err)) {
                throw new Error(err.response?.data?.error || "Não foi possível salvar o favorito")
            }
            if (err instanceof Error) {
                throw err
            }
            throw new Error("Não foi possível salvar o favorito")
        }
    }
    async delete(id: string): Promise<void> {
        try {
            await this.api.delete<void>(`favoritos/${id}`)
        } catch (err) {
            if (isAxiosError(err)) {
                throw new Error(err.response?.data?.error || "Não foi possível salvar o favorito")
            }
            if (err instanceof Error) {
                throw err
            }
            throw new Error("Não foi possível salvar o favorito")
        }
    }
}